import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { HOOK__image_drag } from '@/pages/page_generation/_hooks/HOOK__image_drag';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DRAG_AND_DROP__image_compare__internal } from '../ui/DRAG_AND_DROP__image_compare__internal';

interface PROPS {
  image_a: HTMLImageElement;
  image_b: HTMLImageElement;

  image_a_dto: DTO__image_asset;
  image_b_dto: DTO__image_asset;
}

/** Mode 2: Side-By-Side (Pure React + HTML/CSS) */
export function IMAGE_COMPARE__mode_side_by_side({
  image_a,
  image_b,
  //
  image_a_dto,
  image_b_dto,
  //
}: PROPS) {
  const { grid2d_image_compare__use_image_a_asperation_ratio } = use_slice_ui(['grid2d_image_compare__use_image_a_asperation_ratio']);

  const is_image_a_valid = image_a !== ENUM__html_ref_stub.IMAGE;

  let { onDragStart, onDragEnd } = HOOK__image_drag(image_b_dto);

  /*
   *
   */

  function render_image_a() {
    let out = null;
    if (image_a == ENUM__html_ref_stub.IMAGE) {
      out = render_no_image();
    } else {
      out = <img src={(image_a as HTMLImageElement).src} className="max-w-full max-h-full object-contain pointer-events-none" />;
    }

    out = (
      <>
        {out}
        <DRAG_AND_DROP__image_compare__internal />
      </>
    );

    return out;
  }

  function render_image_b() {
    if (image_b == ENUM__html_ref_stub.IMAGE) return render_no_image();

    let aspectRatioA =
      grid2d_image_compare__use_image_a_asperation_ratio && is_image_a_valid
        ? (image_a as HTMLImageElement).naturalWidth / (image_a as HTMLImageElement).naturalHeight
        : null;

    return (
      <img
        {...{ onDragStart, onDragEnd }}
        style={aspectRatioA ? { aspectRatio: `${aspectRatioA}` } : {}}
        draggable={true}
        src={(image_b as HTMLImageElement).src}
        className="max-w-full max-h-full object-fit cursor-grab"
      />
    );
  }

  function render_no_image() {
    return <div className="text-xs text-neutral-500">No Image</div>;
  }

  function render_view(children: JSX.Element) {
    return <div className="relative flex-1 flex items-center justify-center overflow-hidden bg-black/20 rounded">{children}</div>;
  }

  //    <div className="absolute top-3 left-3 flex items-center justify-center size-6 rounded-full bg-black/75 text-white text-xs font-semibold shadow border border-white/20">
  //           A
  //         </div>

  //         <div className="absolute top-3 right-3 flex items-center justify-center size-6 rounded-full bg-black/75 text-white text-xs font-semibold shadow border border-white/20">
  //           B
  //         </div>

  // Calculate target aspect ratio from Image A if requested

  /*
   *
   */

  return (
    <div className="relative flex w-full h-full gap-2 bg-[#171717] overflow-hidden p-2 select-none">
      {/* --- Image Cell A --- */}
      {render_view(render_image_a())}
      {render_view(render_image_b())}
    </div>
  );
}
